<div>
  <app-page-title [text]="'articles.pageTitle' | fms" [description]="'articles.pageSubtitle' | fms"></app-page-title>
  <h2>{{ "articles.subHeader" | fms }}</h2>
  <section class="mt-16">
    <stb-chip
      [rebrand]="true"
      [iconName]="'check'"
      [chipType]="'choice'"
      [formControl]="articles"
      (chipClicked)="setFilter($event.chip)"
      chipType="choice"
    ></stb-chip>
  </section>
  @if (isEnglish) {
    <section class="mt-24">
      <stb-alert [surfaceVariant]="'surface-1'" type="info" width="fluid" [rebrand]="true">
        {{ "articles.articlesOverview.noTranslationsAlert" | fms }}
      </stb-alert>
    </section>
  }
  <section class="mt-32 articles">
    @for (article of articles$ | async; track article.key) {
      @if (article.openInNewTab) {
        <stb-card-nav
          [surfaceVariant]="'surface-1'"
          [fluid]="true"
          [orientation]="'horizontal'"
          [title]="article.title"
          [trackId]="'link-article-card-' + article.key"
          [href]="article.url"
          [target]="'_blank'"
        >
        </stb-card-nav>
      } @else {
        <stb-card-nav
          [surfaceVariant]="'surface-1'"
          [fluid]="true"
          [orientation]="'horizontal'"
          [title]="article.title"
          [trackId]="'link-article-card-' + article.key"
          [routerLink]="article.route"
        >
        </stb-card-nav>
      }
    }
  </section>
  <section class="mt-48">
    <h2 class="mb-16">{{ "articles.faq.header" | fms }}</h2>
    <section class="faq-section">
      <app-card>
        <app-articles-faq></app-articles-faq>
      </app-card>
      <app-card>
        <img
          [src]="'articles.contactCard.icon' | fms"
          [alt]="'articles.contactCard.icon.alt' | fms"
          class="contact-card-icon"
        />
        <h3 class="mt-16">{{ "articles.contactCard.title" | fms }}</h3>
        <p class="font-body-small-demibold mt-24">{{ "articles.contactCard.privateQuestion" | fms }}</p>
        <p class="mt-08">
          <a [href]="'articles.contactCard.sendEmail.link' | fms" target="_blank">{{
            "articles.contactCard.sendEmail" | fms
          }}</a>
        </p>
        <p>
          <span>{{ "articles.contactCard.call" | fms }}</span
          >&nbsp;
          <a [href]="'tel:' + ('articles.contactCard.callPrivate' | fms).split(' ').join('')">
            {{ "articles.contactCard.callPrivate" | fms }}
          </a>
        </p>
        <p class="font-body-small-demibold mt-24">{{ "articles.contactCard.publicPensionQuestion" | fms }}</p>
        <p class="mt-08">
          <a [href]="'articles.contactCard.sendEmailPublicPension.link' | fms" target="_blank">{{
            "articles.contactCard.sendEmail" | fms
          }}</a>
        </p>
        <p>
          <span>{{ "articles.contactCard.call" | fms }}</span
          >&nbsp;
          <a [href]="'tel:' + ('articles.contactCard.callPublic' | fms).split(' ').join('')">
            {{ "articles.contactCard.callPublic" | fms }}
          </a>
        </p>
        <p class="font-body-small-demibold mt-24">{{ "articles.contactCard.question" | fms }}</p>
        <p class="mt-08">
          <a [href]="'articles.contactCard.sendEmail.link' | fms" target="_blank">{{
            "articles.contactCard.sendEmail" | fms
          }}</a>
        </p>
        <p>
          <span>{{ "articles.contactCard.call" | fms }}</span
          >&nbsp;
          <a [href]="'tel:' + ('articles.contactCard.callPrivate' | fms).split(' ').join('')">
            {{ "articles.contactCard.callPrivate" | fms }}
          </a>
        </p>
        <p class="font-body-small-demibold mt-24">{{ "articles.contactCard.payoutQuestion" | fms }}</p>
        <p class="mt-08">
          <a [href]="'articles.contactCard.sendEmailPayout.link' | fms" target="_blank">{{
            "articles.contactCard.sendEmail" | fms
          }}</a>
        </p>
        <p>
          <span>{{ "articles.contactCard.call" | fms }}</span
          >&nbsp;
          <a [href]="'tel:' + ('articles.contactCard.callPayout' | fms).split(' ').join('')">
            {{ "articles.contactCard.callPayout" | fms }}
          </a>
        </p>
      </app-card>
    </section>
  </section>
</div>
